import { ClientType } from '../features/clients/Clients.types';
import { usePostFetch } from '../utils/reactQuery';
import { pathToUrl } from '../utils/router';
import { ApiRoutesEnum } from '../utils/routes';

export type FetchUsersResponseType = {
  count: number;
  results: ClientType[];
};

export const useGetAllClients = () =>
  usePostFetch<FetchUsersResponseType>(pathToUrl(ApiRoutesEnum.searchClients), { criteria: [], max: 10000 });
